import { reactive, computed } from 'vue'
import FormattingService from '@/services/formatting.service';

export default {
  name: 'InstructorCard',
  props: {
    instructor: {
      type: Object,
      required: true,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    defaultCollection: {
      type: Boolean,
      default: true,
    }
  },  
  setup (props) {

    const state = reactive({
      instructor: computed(() => props.instructor),
      name: computed(() => {
        if(state.instructor) {
          let splitName = state.instructor.title.split(" ");
          let firstName = splitName.shift();
          let lastName = splitName.join(" ");
          return `${firstName}<strong> ${lastName}</strong>`;
        }
        return '';
      }),
      isMobile: computed(() => {return props.isMobile})
    });

    return {
      state,
      FormattingService
    }
  },
}